// A simple tree class with user-defined node shape, parent references, and predicate finders.
export default class Tree {
  constructor() {
    // @ts-ignore
    this._root = {
      children: [],
    };
  }

  get root() {
    // @ts-ignore
    return this._root;
  }

  find(node, where) {
    node = node || this.root;

    // check immediate children
    if (where(node)) {
      return node;
    }

    for (const child of node.children) {
      // check this child's children
      const childNode = this.find(child, where);

      if (childNode) {
        return childNode;
      }
    }

    return null;
  }

  removeNode(where) {
    const node = this.find(null, where);

    if (node) {
      node.parent.children = node.parent.children.filter((o) => o === node);
    }
  }

  insertNode(where, attributes) {
    const parent = this.find(null, where) || this.root;

    parent.children.push({
      ...attributes,
      children: [],
      parent,
    });
  }
}
